import React, { Component } from 'react';
import { Breakpoints } from '@capcenter/shared';

export class Breakpoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: '',
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth < Breakpoints.small) {
      if (this.state.size !== 'xSmall') {
        this.setState({ size: 'xSmall' });
      }
    } else if (window.innerWidth < Breakpoints.medium) {
      if (this.state.size !== 'small') {
        this.setState({ size: 'small' });
      }
    } else if (window.innerWidth < Breakpoints.large) {
      if (this.state.size !== 'medium') {
        this.setState({ size: 'medium' });
      }
    } else if (window.innerWidth < Breakpoints.xLarge) {
      if (this.state.size !== 'large') {
        this.setState({ size: 'large' });
      }
    } else if (this.state.size !== 'xLarge') {
      //console.log("xLarge")
      this.setState({ size: 'xLarge' });
    }
  };

  render() {
    return <>{this.props.children({ size: this.state.size })}</>;
  }
}
export default Breakpoint;
